import React from 'react'

const defaultServices = [
    { icon: 'fa-gears', title: 'Tailored App Design Solutions', text: 'We create custom app designs that are user-centric and unique—blending functionality with creativity for visually stunning, responsive, and seamless experiences aligned to your goals and brand.' },
    { icon: 'fa-mobile', title: 'Mobile-Responsive UI/UX App Design', text: 'We design apps that adapt effortlessly to all screen sizes—delivering smooth UX, fast loading times, and optimal performance on any device.' },
    { icon: 'fa-keyboard-o', title: 'App Programming Excellence', text: 'We build scalable, secure, and high-speed mobile apps using modern stacks and best practices—ensuring exceptional performance and seamless functionality across platforms.' },
    { icon: 'fa-btc', title: 'Web 3.0 App Solutions', text: 'We build Web 3.0 apps with blockchain, dApps, and AI-driven platforms. Our smart contract expertise ensures secure, transparent, and automated systems tailored to your needs.' },
    { icon: 'fa-shopping-bag', title: 'E-Commerce App Solutions', text: 'We build custom e-commerce apps with intuitive UI, secure payments, and scalable features to elevate the shopping experience and increase conversions.' },
    { icon: 'fa-hotel', title: 'Hotel Management App Solutions', text: 'We build hotel management apps with automation tools, guest management, and booking systems to streamline operations, enhance experiences, and grow revenue.' },
    { icon: 'fa-file-text-o', title: 'Content Management App Solutions', text: 'We create CMS-driven apps that simplify creating, editing, and managing content—delivering a seamless UX, scalability, and a flexible, easy-to-use system.' },
    { icon: 'fa-link', title: 'Bespoke App Development', text: 'We deliver high-performing Android and iOS apps tailored to your business goals. Our custom approach ensures smooth user experiences with robust functionality for diverse needs.' },
    { icon: 'fa-user-circle-o', title: 'Lifetime Customer Support', text: 'As a reliable App Development Company in Pakistan, we offer ongoing support, updates, and troubleshooting to ensure smooth performance and long-term reliability for your app.' },
    { icon: 'fa-globe', title: 'Cutting-Edge Technology', text: 'We use the latest technologies to build innovative, high-performing mobile applications with advanced features—ensuring scalability, robust security, and a future-proof presence.' },
]

const AppServices = ({
    eyebrow = 'SERVICES',
    title = 'App Services We Offer',
    subtitle = 'We provide a complete package of innovative services covering',
    services = defaultServices
}) => {
    return (
        <>
            <div id='services' className='black-themetwo' style={{ background: "linear-gradient(rgba(0,0,0,1), rgba(0,0,0,0))" }}>
                <div className=" text-center">
                    <h2 className='h5 fw-bold' style={{ color: '#6565ff' }}>{eyebrow}</h2>
                    <h2 className='py-2 h4 fw-bold'>{title}</h2>
                    <h2 className='px-2 blockquote display-6 h1 fw-bold'>{subtitle}</h2>
               
                    <div className="container-fluid my-3 py-3">
                        <div className="row">
                            {services.map((service) => (
                                <div key={service.title} className="col-md-4 col-12 my-2" data-aos="zoom-in-up" data-aos-duration="1000">
                                    <div className="card rounded-4 h-100 overflow-hidden" style={{ borderColor: "#6565ff" }}>
                                        <div className='pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                            <div className='display-1 h1'>
                                                <i aria-hidden="true" style={{ color: '#6565ff' }} className={`fa ${service.icon} fa-lg`}></i>
                                            </div>
                                        </div>
                                        <div className="card-body d-flex flex-column">
                                            <h3 className="card-title h5 fw-bold">{service.title}</h3>
                                            <p className="card-text">{service.text}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AppServices
